export default __webpack_public_path__ + "img/eWePoiEm.cd3d2b71.svg";